import mapbox from 'mapbox-gl';

// https://docs.mapbox.com/help/glossary/access-token/
mapbox.accessToken = "pk.eyJ1IjoiYnJwYSIsImEiOiJja2Z6amF0bmIwa3QzMzBtN2t1YWVxMnNlIn0.W7seLJ4u1aJsNJokrZ4dgg";

const key = {};

export { mapbox, key };